import styled from 'styled-components';

import { CaixaSeletorDeCor } from '../../../styles';

export const SeletorDeCorEstilizado = styled(CaixaSeletorDeCor)`
  & {
    margin-left: 20px;
  }
`;
